/* eslint-disable react-hooks/exhaustive-deps */
import { Divider } from 'antd'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { CustomCard, CustomTable } from 'src/components'
import { adminSaleOfferColumns } from 'src/core/table-columns'
import { getAdminSaleOffersFiltered } from 'src/core/helpers'
import AdminSaleOfferListHeader from './AdminSaleOfferListHeader/AdminSaleOfferListHeader'
import { AdminSaleOffer, AdminSaleOfferFilterState, AdminSaleOfferGroup } from 'src/core/models'

const AdminSaleOffersGroupList: React.FC<{ group: AdminSaleOfferGroup }> = ({ group }) => {
  const { t } = useTranslation()
  const [filteredOffers, setFilteredOffers] = useState<AdminSaleOffer[]>(group.sale_offers || [])
  const [filters, setFilters] = useState<AdminSaleOfferFilterState>({ status: 'all', text: null })

  useEffect(() => {
    const newFilteredOffers = getAdminSaleOffersFiltered(filters, group.sale_offers)
    setFilteredOffers(newFilteredOffers)
  }, [filters, group.sale_offers])

  return (
    <div className={'collapse-animation'}>
      <CustomCard>
        <AdminSaleOfferListHeader
          filters={filters}
          length={filteredOffers.length}
          updateState={(values) => setFilters(values)}
        />
        <Divider />
        <CustomTable
          dataSource={filteredOffers}
          columns={adminSaleOfferColumns}
          rowKey={(item: AdminSaleOffer) => item.id}
          rowClassName={'fade-animation'}
          emptyText={t('SalesOffer.Empty')}
        />
      </CustomCard>
    </div>
  )
}
export default AdminSaleOffersGroupList
